import moment from "moment";

export const renderSidebar = (sideBarLinks, user) => {
  let tempSidebar = sideBarLinks.filter(
    ({ key }) =>
      user?.privileges.includes(key) || key === "" || key === user.type
  );
  return tempSidebar;
};

export const numberWithCommas = (number) => {
  const formattedNumber = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(number);

  return formattedNumber.replace(/\.00$/, "");
};
export const getOriginalAmount = (paidAmount, gstRate) => {
  const getOriginalAmount = paidAmount / (1 + gstRate / 100);
  return getOriginalAmount;
};
export const gstAmount = (paidAmount, gstRate) => {
  const originalGstAmount = ((paidAmount / 118) * gstRate).toFixed(2);
  return originalGstAmount;
};

export const getQueryString = (params) => {
  return new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(
        ([, value]) => value !== "" && value !== undefined && value !== null
      )
    )
  ).toString();
};
